import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { styled, Typography } from '@mui/material';

import { MplTrans } from '@mopla/i18';
import {
	FlexColumn,
	IconMessage,
	InfoBaseIcon,
	MplPaper,
	PageLoadingIndicator,
} from '@mopla/ui';

interface IDTicketPaymentMethodProps {
	isPreparing?: boolean;
}

const LoaderWrapper = styled('div')(() => ({
	width: '100%',
	display: 'grid',
	justifyContent: 'center',
}));

export const DTicketPaymentMethod: FC<IDTicketPaymentMethodProps> = ({
	isPreparing,
}) => {
	const { t } = useTranslation('booking');

	return (
		<MplPaper>
			<Typography variant="bodyTitle">
				{t('payment.no_payment_method_subtitle')}
			</Typography>
			<FlexColumn gap={16} sx={{ mt: 2 }}>
				{isPreparing ? (
					<LoaderWrapper>
						<PageLoadingIndicator />
					</LoaderWrapper>
				) : (
					<>
						<span data-testid="booking-purchaseSummary-paymentMethod-text">
							<MplTrans ns="booking" i18nKey="payment.no_payment_method_body" />
						</span>
						<IconMessage
							icon={<InfoBaseIcon />}
							message={t('payment.no_payment_method_info')}
						/>
					</>
				)}
			</FlexColumn>
		</MplPaper>
	);
};
